<script>
	import Steps from '../Steps';
	import swal from 'sweetalert';
	import { mapState,mapMutations } from 'vuex';
	import AddFiles from '../modals/AddFiles.vue';
	import {stepFiveTarget} from '../../stepsTargets.js';

	export default{
		props:{
			reviewApprove: {
				type: Boolean,
				default: false
			}
		},
		components:{Steps,AddFiles},
		data(){
			return{
				comentario:'',
				files:[],
				steps: stepFiveTarget,
				myOptions:{
					labels: {
						buttonSkip: 'Saltar instrucciones',
						buttonPrevious: 'Anterior',
						buttonNext: 'Siguiente',
						buttonStop: 'Terminar paso'
					}
				},
			}
		},
		computed:{
			...mapState(['stepActive','stepFive','alertas'])
		},
		mounted(){
			if(this.stepActive == 5 && this.alertas){
				this.$tours['stepFive'].start();
			}
		},
		methods:{
			...mapMutations(['changeStepActive','saveStepFive']),
			saveStep(){
				if(this.stepFive.comentarios.length == 0){
					swal({title: "¡Atención!",text: 'Debes capturar al menos un comentario para continuar.',icon: "warning",button: 'Aceptar'});
				}else if(this.stepFive.documents.length == 0){
					swal({title: "¡Atención!",text: 'Debes adjuntar al menos un archivo para continuar.',icon: "warning",button: 'Aceptar'});
				}else{
					this.changeStepActive(this.stepActive+1)
					this.saveStepFive(this.stepFive);
				}
			},
			addComment(){
				this.stepFive.comentarios.push(this.comentario);
				this.comentario = '';
			},
			openModalAddFiles(){
				window.$('#add-file').modal('show');
			},
			setAdjuntos(evt){
				this.stepFive.documents.push(evt);
			},
			restartTour(){
				this.$tours['stepFive'].start();
			}
		}
	}
</script>
<template>
	<div class="contenido">
		<v-tour name="stepFive" :steps="steps" :options="myOptions"/>
		<div v-if="!reviewApprove">
			<div class="header-tools">
				<div class="title">
					Crear Solicitud Acuerdo: Paso 5 (Adjuntos)
				</div>
				<div class="buttons">
					<div>
						<button @click="changeStepActive(stepActive-1)"> <i class="fas fa-chevron-left"></i> Atrás </button>
						<!-- <button>Continuar <i class="fas fa-chevron-right"></i></button> -->
						<span class="separator-buttons">|</span>
						<button data-v-step="40" @click="saveStep();"> Guardar </button>
						<button> Cancelar </button>
						| <button v-if="alertas" @click="restartTour()" class="btn-icon"><i class="fas fa-question-circle"></i> Instrucciones</button>
					</div>
				</div>
			</div>
			<steps :stepActive="stepActive"/>
			<hr class="separator-steps-content">
		</div>
		<div class="container">
			<div class="information-general">
				<div class="title">
					Adjuntos
				</div>
				<div class="info-body">
					<div class="row">
						<div class="col-md-8">
							<div class="row mb-10">
								<div class="col-md-4">Nueva Solicitud Acuerdo</div>
								<div class="col-md-4">Tipo Sol. Acuerdo: Volumen</div>
								<div class="col-md-4">Solicitud Acuerdo:</div>
							</div>
							<div class="row mb-25">
								<div class="col-md-4">Estado: Borrador Solicitud Acuerdo</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-8 table-options mt-10">
				<div class="buttons">
					<button> Export </button>
				</div>
				<table class="table-proveedor">
					<tr>
						<td>&nbsp;</td>
						<td>Nombre Archivo</td>
						<td>Vista</td>
						<td>Tipo Archivo</td>
						<td>ID Creador</td>
					</tr>
					<tr v-for="(file,index) in stepFive.documents" :key="index">
						<td>&nbsp;</td>
						<td>{{file.file}}</td>
						<td></td>
						<td>{{file.type}}</td>
						<td></td>
					</tr>
					<tr v-if="stepFive.documents.length == 0">
						<td></td>
						<td colspan="4">La tabla no contiene datos.</td>
					</tr>
				</table>
				<div class="buttons no-bg">
					<button data-v-step="37" data-toggle="modal" data-target="#add-file"><i class="far fa-file"></i> Agregar Adjunto</button>
					<button><i class="fas fa-trash-alt"></i> Borrar</button>
				</div>
				<add-files @loadFile="setAdjuntos($event)"/>

				<div class="subtitle-content mt-20">
					Comentarios
				</div>
				<div class="row">
					<div class="col-md-12 radios">
						<label class="radio-inline"><input type="radio" v-model="stepFive.visibilidad" name="visibleProvider" value="Visible al proveedor">Visible al proveedor</label>
						<label class="radio-inline"><input type="radio" v-model="stepFive.visibilidad" name="visibleProvider" value="Interno  Solamente">Interno  Solamente</label>
						<label class="checkbox-inline"><input type="checkbox" v-model="stepFive.imprimir" name="printBill">Imprimir Factura</label>
					</div>
					<div class="col-md-12 mt-20 buttons no-bg" data-v-step="39">
						<textarea v-model="comentario" class="form-control" rows="6"></textarea>
						<button @click="addComment()">Agregar Comentario</button>
					</div>
				</div>
				<div class="subtitle-content mt-20">
					Comentarios guardados
				</div>
				<blockquote v-for="(comment,index) in stepFive.comentarios" :key="index">
					{{comment}}
				</blockquote>
			</div>
		</div>
	</div>
</template>